import { DateHelpers } from '@/helpers/date-helpers';
import type { CompetitorInfo } from '../shared/types/rate-shop-types';
import { formatTooltipValue } from '../shared/utils/rate-formatters';

interface ChartTooltipProps {
  active?: boolean;
  payload?: any[];
  label?: any;
  competitorInfo: CompetitorInfo[];
}

export const ChartTooltip = ({ active, payload, label, competitorInfo }: ChartTooltipProps) => {
  if (!active || !payload || payload.length === 0) return null;

  // Filter out entries with null/undefined values
  const validEntries = payload?.filter(
    (entry) => entry.value !== null && entry.value !== undefined && !Number.isNaN(entry.value),
  );

  if (validEntries.length === 0) return null;

  // Get the actual date from the first entry's payload data
  const actualDate = validEntries[0]?.payload?.date || label || null;

  return (
    <div className='rounded-lg border bg-background p-3 shadow-md'>
      <div className='space-y-2'>
        {/* Date header */}
        <div className='font-bold text-sm text-muted-foreground border-b pb-1'>
          {DateHelpers.formatDate(actualDate, 'MMM D, YYYY')}
        </div>

        {/* Compact rate rows: $rate HotelName */}
        <div className='space-y-1'>
          {validEntries.map((entry, index: number) => {
            // Find column info to determine if this is Price Index
            const columnData = competitorInfo.find((col) => col.dataKey === entry.dataKey);

            // Check if this entry is sold out
            const isSoldOut = entry.payload[`${entry.dataKey}_soldOut`];

            // Format value based on type and sold-out status
            const baseValue = formatTooltipValue(entry.value, columnData?.type || 'competitor');
            const displayValue = isSoldOut ? `Sold Out (was ${baseValue})` : baseValue;

            return (
              <div key={index} className='flex items-center gap-2 text-sm'>
                <span
                  className={`font-bold ${isSoldOut ? 'opacity-60' : ''}`}
                  style={{ color: isSoldOut ? 'rgb(239 68 68)' : entry.color }}
                >
                  {displayValue}
                </span>
                <span className='text-muted-foreground'>{columnData?.name || entry.dataKey}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
